import { render, staticRenderFns } from "./PlayerDiagnosticTrendChart.vue?vue&type=template&id=2bbb9c68"
import script from "./PlayerDiagnosticTrendChart.vue?vue&type=script&lang=js"
export * from "./PlayerDiagnosticTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports